import 'react-toastify/dist/ReactToastify.css';
import './dustControl/assets/styles/app.scss';
import './scrapBins/assets/styles/app.scss';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Dashboard from './dustControl/pages/Dashboard/index';
import { SocketProvider } from './dustControl/utils/socket';
import ManageUser from './manageUser';
import Login from './pages/Login';
import { UserContext, UserState } from './pages/service/userContext';
import React, { Suspense } from 'react';
import { Link } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Spinners from './dustControl/components/spinner';
import { links } from './dustControl/utils/constants';
import {
  ProtectRoute,
  RedirectToLandingPage,
} from './pages/service/protectRoute';
import PreStartChecks from './preStartChecks';
import Summary from './preStartChecks/Summary';
import Report1 from './preStartChecks/Components/reports/report-1';
import MaterialMovementReport from './materialMovements/components/Report/MaterialMovementReport';
// import AssetMonitoring from './assetMonitoring/AssetMonitoring';
import ScrapBins from './scrapBins';
import { ScrapBinsProvider } from './scrapBins/context/scranBinsContext';
import Maintenance from './maintenance';
import MaterialMovements from './materialMovements/pages/Dashboard/index';

import { AssetTracking } from '@optitrac/components';
import { withAccessControl } from './pages/service/with-access-control';
import { GlobalContext, GlobalProvider } from './pages/service/globalContext';
import { CallWithAuth } from './pages/service/apiActions';
import { getAccessToken } from './pages/service/accessToken';
import { WebSocketURL } from './utils/constants';
import { getUrl } from './materialMovements/pages/shiftLoader/helper';
import ErrorBoundary from './scrapBins/ErrorBoundary';
import KPIDashboard from './pages/KPIDashboard/index';

const Unauthorized = React.lazy(() => import('./pages/unauthorized'));
const PasswordChanged = React.lazy(
  () => import('./pages/profile/set-password/password-set-message'),
);
const InvalidLink = React.lazy(
  () => import('./pages/profile/set-password/Invalid-password-reset-link'),
);
const SetPassword = React.lazy(() => import('./pages/profile/set-password'));
const LandingPage = React.lazy(() => import('./pages/landingPage'));
const ForgotPassword = React.lazy(
  () => import('./pages/profile/ForgotPassword'),
);

const AppRoutes = () => {
  return (
    <>
      <div style={{ zIndex: 1, height: '100%' }}>
        <Suspense fallback={<Spinners />}>
          <Routes>
            {/* protected routes -- must be logged in */}
            <Route element={<ProtectRoute />}>
              <Route path="/dust-control" element={<Dashboard code={100} />} />
              <Route path="/landing-page" element={<LandingPage />}></Route>
              <Route
                path="/user-management"
                element={<ManageUser code={700} />}
              />
              <Route
                path="/pre-start-check"
                element={<PreStartChecks code={600} />}
              />
              <Route
                path="/kpi-dashboard"
                element={<KPIDashboard code={500} />}
              />
              <Route
                path="/material-movements"
                element={<MaterialMovements code={200} />}
              />
              <Route
                path="/asset-tracking"
                element={
                  <ErrorBoundary>
                    <AssetTracking
                      code={800}
                      GlobalContext={GlobalContext}
                      UserContext={UserContext}
                      useLocation={useLocation}
                      useNavigate={useNavigate}
                      withAccessControl={withAccessControl}
                      getAccessToken={getAccessToken}
                      publicLambdaBaseUrl={getUrl()}
                      websocketBaseUrl={WebSocketURL}
                      CallWithAuth={CallWithAuth}
                      mapCenter={{ lat: -37.202865, long: 174.7290959 }}
                      maxZoom={4815}
                      cameraDistance={4814}
                      displayLargeDroneImage={true}
                      displaySmallDroneImage={true}
                    />
                  </ErrorBoundary>
                }
              />
              <Route
                path="/scrap-bins"
                element={
                  <ScrapBinsProvider>
                    <ScrapBins code={400} />
                  </ScrapBinsProvider>
                }
              />

              <Route path="/maintenance" element={<Maintenance code={300} />} />
              {/* @ts-expect-error props will be undefined when navigating from Route, because they will be passed in as query params */}
              <Route path="/summary" element={<Summary code={200} />} />
              {/* @ts-expect-error props will be undefined when navigating from Route, because they will be passed in as query params */}
              <Route path="/prestart-report" element={<Report1 code={200} />} />
              <Route
                path="/material-report"
                // @ts-expect-error props will be undefined when navigating from Route, because they will be passed in as query params
                element={<MaterialMovementReport code={200} />}
              />
              <Route
                path="*"
                element={
                  <div className="h-100 d-flex justify-content-center align-items-center flex-column">
                    <h1 className="display-1">404</h1>
                    <h2>Ooops, page not found!</h2>
                    <Link to="/landing-page">Go back</Link>
                  </div>
                }
              />
            </Route>

            {/* protected routes -- must not be logged in */}
            <Route element={<RedirectToLandingPage />}>
              <Route path="/" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
            </Route>

            {/* public routes */}
            <Route path="/set-password" element={<SetPassword />} />
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="/password-changed" element={<PasswordChanged />} />
            <Route path="/invalid-link" element={<InvalidLink />} />
          </Routes>
        </Suspense>
      </div>
    </>
  );
};

const App = () => {
  return (
    <div className="app">
      <SocketProvider>
        <UserState>
          <GlobalProvider>
            <AppRoutes />
          </GlobalProvider>
        </UserState>
      </SocketProvider>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

export default App;
